import styles from './DataTab.module.scss';
import ContactDetails from '../../components/ContactDetails';
import LoginDetails from '../../components/LoginDetails';
import PartnerCodeDetails from '../../components/PartnerCodeDetails';
import PhoneDetails from '@src/pages/ProfilePage/components/PhoneDetails';
import WeChatDetails from '../../components/WeChatDetails/WeChatDetails';
import { IDataTabProps } from '@src/pages/ProfilePage/types';
import { useProfile } from '@contexts/ProfileContext';

const DataTab: React.FC<IDataTabProps> = (props: IDataTabProps): React.ReactElement => {
  const { refetchWallets } = props;

  const { account } = useProfile();

  return (
      <div className={styles.grid}>
        <div className={styles.col}>
          <ContactDetails/>
          <PartnerCodeDetails/>
          <PhoneDetails/>
          <LoginDetails/>
        </div>
        <div className={styles.col}>
          {account?.region === 'CN' && <WeChatDetails refetchWallets={refetchWallets}/>}
        </div>
      </div>
  );
};

export default DataTab;